[
    {
        "category": "😍 Love It",
        "folder": "a",
        "count": 3
    },
    {
        "category": "🤩 Wow",
        "folder": "b",
        "count": 3
    },
    {
        "category": "😮 Omg",
        "folder": "c",
        "count": 4
    },
    {
        "category": "🥹 So Sweet",
        "folder": "d",
        "count": 5
    },
    {
        "category": "😊 I'm Happy",
        "folder": "e",
        "count": 6
    },
    {
        "category": "🥰 In Love",
        "folder": "f",
        "count": 4
    },
    {
        "category": "😂 Hilarious",
        "folder": "g",
        "count": 3
    },
    {
        "category": "😆 Hahaha",
        "folder": "h",
        "count": 3
    },
    {
        "category": "🥳 Kudos",
        "folder": "i",
        "count": 3
    },
    {
        "category": "😇 Angelic",
        "folder": "j",
        "count": 3
    },
    {
        "category": "🤤 Yummy",
        "folder": "k",
        "count": 3
    },
    {
        "category": "🤯 Mind Blown",
        "folder": "l",
        "count": 3
    },
    {
        "category": "😭 So Sorry",
        "folder": "m",
        "count": 6
    }
]
